export enum AlertVariant {
  Blue = 'blue',
  Green = 'green',
  Grey = 'grey',
  Red = 'red',
  Yellow = 'yellow',
  Electric = 'electric',
  West = 'west',
}
